import React from 'react'
import {Lang} from 'yougile-lang'
import {MessageBox} from '@components/message-box'

export const showErrorNotAllowedCreateMirror = () => {
  MessageBox.warn(
    Lang.msg.permissionsForbiddenCreateMirrorP1 +
      ' ' +
      Lang.msg.permissionsForbiddenCreateMirrorP2,
    {
      style: {width: '600px'},
      children: (
        <>
          {Lang.msg.permissionsForbiddenCreateMirrorP1}
          <br />
          {Lang.msg.permissionsForbiddenCreateMirrorP2}
        </>
      )
    }
  )
}

export const showErrorCannotCreateMirrorFromSubtask = () => {
  MessageBox.warn(
    Lang.msg.permissionsForbiddenCreateMirrorFromSubtaskP1 +
      ' ' +
      Lang.msg.permissionsForbiddenCreateMirrorFromSubtaskP2,
    {
      style: {width: '600px'},
      children: (
        <>
          {Lang.msg.permissionsForbiddenCreateMirrorFromSubtaskP1}
          <br />
          {Lang.msg.permissionsForbiddenCreateMirrorFromSubtaskP2}
        </>
      )
    }
  )
}

export const showErrorNotSupportDragFromReports = () => {
  MessageBox.warn(
    Lang.msg.notSupportDragFromReportsP1 +
      ' ' +
      Lang.msg.notSupportDragFromReportsP2,
    {
      style: {width: '600px'},
      children: (
        <>
          {Lang.msg.notSupportDragFromReportsP1}
          <br />
          {Lang.msg.notSupportDragFromReportsP2}
        </>
      )
    }
  )
}
